import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface ArYodaRulesPublishedNotifyFollowersProps extends BaseTemplateProps {
  request: {
    name: string
  }
}

export const ArYodaRulesPublishedNotifyFollowers: TemplateDefinition<ArYodaRulesPublishedNotifyFollowersProps> =
  {
    renderParams: (props: ArYodaRulesPublishedNotifyFollowersProps) => ({
      messageKey: 'notificationsDomain.templates.arYodaRulesPublishedNotifyFollowers',
      values: {
        ruleName: props?.request?.name,
      },
    }),
  }
